import { render, staticRenderFns } from "./PassengerBox.vue?vue&type=template&id=7a493ce2&"
import script from "./PassengerBox.vue?vue&type=script&lang=js&"
export * from "./PassengerBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports